import organizationService from './OrganizationService';
import dashboardService from './DashboardService';
import deviceService from './DeviceService';
import userService from './UserService';
import activityLogService from './ActivityLogService';
import emergencyAlertService from './EmergencyAlertService';
import tagService from './TagService';

export const API = {
    ...organizationService,
    ...dashboardService,
    ...deviceService,
    ...userService,
    ...activityLogService,
    ...tagService,
    ...emergencyAlertService,
};
